import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

const Step = ({ number, name, descrip }: any) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        borderRadius: "16px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyItems: "center",
        justifyContent: "center",
        border: "1px solid #E7EEFF",
        width: "100%",
        padding: "24px",
        gap: 2,
      }}
    >
      <Box
        sx={{
          borderRadius: "9999px",
          backgroundColor: "#DDE1FF",
          width: 48,
          height: 48,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          justifyItems: "center",
        }}
      >
        {number}
      </Box>
      <Typography
        variant="h4"
        fontWeight={700}
        sx={{ color: theme.palette.mode === "dark" ? "white" : "black" }}
      >
        {name}
      </Typography>
      <Typography
        variant="body1"
        sx={{ color: theme.palette.mode === "dark" ? "white" : "black" }}
      >
        {descrip}
      </Typography>
    </Box>
  );
};

export default Step;
